import { createContext, useContext } from "react";

import AppReduxProvider from "./AppReduxProvider";
import App from "./App";
import AppRouter from "./Routing/AppRouter";
import useSilentSsoAuth from "./Utils/useSilentSsoAuth";

// Allow sub components to access the props that were passed to the app container from the
// backend through the DOM.
export const AppContainerPropsContext = createContext();
export const useAppContainerProps = () => useContext(AppContainerPropsContext);

const AppContainer = props => {
  useSilentSsoAuth(props.ssoSilentAuthUrl);

  return (
    <AppContainerPropsContext.Provider value={props}>
      <AppReduxProvider>
        <App>
          <AppRouter />
        </App>
      </AppReduxProvider>
    </AppContainerPropsContext.Provider>
  );
};

export default AppContainer;
